/*
Description: This is the file that will hanlde interacting with the PromptEMR
Date: 11/21/2023
Author: Jacob Michalski

Notes:
    All Injectors need the following functions:
        getQuestions
        answerQuestions (Consider combining these and making the single a private function)
        answerQuestion

Status: 
    Boatload of "Measurement" questions (Nuking Long Answer)
    Plan shows up as a Long Answer question...


TODO: 
    Scrape the dyanmic tokens - the .Firstname and such...

Prompt Specific Notes:
    Top Level: class: "items-start"
        Child
            Long Answers:
                class: "q-pl-md" (ID is telling us the section)
                Specifically General Note and Plan:
                    class:q-mb-md (Subjective, Objective, Assessment, Plan)
                    var q = document.querySelectorAll('.q-mb-md')
                    q[0].children[0].getAttribute("label") // Get's us the subjective label
                    var sub = q[0].querySelector("textarea")
                    sub.value = "This is a test of the emergency broadcast system..."

            CPT Codes:
                //class: "q-pa-md"
                role="combobox"
                document.querySelectorAll('[role="combobox"]')
                // In this case it was the 3rd one
                var cpt = document.querySelectorAll('[role="combobox"]')[2]
                var questionLabel = getParentSubtitle(cpt)

                # Getting the choices to show up...
                cpt.dispatchEvent(eventFactory("focusin"))
                cpt.dispatchEvent(eventFactory("click"))

                // then the options are in a listbox with role="listbox"
                // We can get the options with
                var lBox = document.querySelectorAll('[role="listbox"]')[0]
                var choices = lBox.querySelectorAll(".q-item__section")
                    choices[14].children[0].textContent // This is the code
                    choices[14].children[1].textContent // This is the description
                    // To Click it
                    if (!choices[14].parentElement.classList.contains("q-item--active")){
                        choices[14].click() // (Toggles so we have to check it first)
                    }

            // Choose All Question - 
            class:"q-pa-md"    
            var q = document.querySelectorAll('.q-pa-md')[6]
            var questionLabel = getChildSubtitle(q)
            var choices = q.querySelectorAll(".q-px-md")
                choices[0].textContent // This is the choice text

                // To Click it
                if (!c.querySelector(".q-checkbox__inner").classList.contains("q-checkbox__inner--truthy"))){
                    c.querySelector(".q-checkbox__inner").click() // This is how we click it
                }
            
            // Multiple Choice ("radioGroup")
            class: "q-pa-md"
            var q = document.querySelectorAll('.q-pa-md')[7]
            qs[7].querySelector(".radioGroup") != null
            var questionLabel = getChildSubtitle(q)
            var choices = q.querySelectorAll("button")
                // This is the choice text
                choices[0].querySelector(".q-btn__content").firstChild.firstChild.textContent 

                // To Click it
                if (!choices[0].classList.contains("bg-p-blue100"))){
                    choices[0].click() // (Toggles so we have to check it first)
                }


            // Long Answer
            class: "q-pa-md"
            var q = document.querySelectorAll('.q-pa-md')[8]
            var questionLabel = getChildSubtitle(q)
            var answer = q.querySelector("textarea")
                answer.value = "This is a test of the emergency broadcast system..."


            // Looking at templates...
                // We can get the templates with
                var t = findTemplate(document)
                t.click()   // Shows the template manager

                var tDialog = document.querySelector('.q-dialog')
                var filter = tDialog.querySelectorAll(".q-field__inner")
                    # 0 is Body Part
                    # 1 is Type ("Subjective, ...")
                    # 2 is Author
                    # 3 is Search
                tDialog.querySelectorAll(".q-field__inner")[0].firstChild.click()

                // We can get the options with
                var lBox = document.querySelectorAll('[role="listbox"]')[0]
                var choices = lBox.querySelectorAll(".q-px-md")
                    // It possible that the first 2 options are not what we want
                    // 0 is search
                    // 1 is select all and clear
                    // 2 is the first option
                    // Not the case for type
                
                // To click on one of the choices
                    choices[0].querySelector('[role="checkbox"]').click()
                
                // For the Type, try to find an exact match in the question, if there is none, don't select anything
                // Note: we will have to clear all the options first
                // Note: we will have to wait for the template list to load
                
                // Scraping the templates after searching 
                var templates = tDialog.querySelector(".q-table__grid-content").children
                # We are grabbing the outer element to get more context. Now strip away some of that context
                templates[0]textContent.split("...see more")[0].trim() // This is the template name


                // To close the template manager
                findElementOfTypeWithText(tDialog, "i", "close").click()




*/

import type { FocusCaptureSource, SectionRead } from './NoteFocusCapture.ts';
import { FLOWSHEET, promptNotePage } from './PromptCapture.ts';
export { getSchedule } from './PromptSchedule.ts';

// async function getPageInfo(){
export async function getPageInfo() {
  /*
    Description: This function will get the page info from the note
    Return: A dictionary with the page info
        {
      "URL": Base URL for the page,
      "Note Type": "PT Daily/SOAP Note",...
    }
    */

  const baseURL = window.location.origin;
  // Rather than hardcode to Prompt Note, be more dynamic

  // The visit dropdown button's first line reads "Wed, 8/19 - Visit 1 - Follow
  // Up"; the last dash-separated part is the visit type. Read it from the
  // button rather than opening its menu: the menu only exists in the DOM while
  // open, and opening it flashed on screen every time this ran.
  let noteType = 'Prompt Note';
  try {
    const dropdown = document.querySelector(
      'button.q-btn-dropdown .q-btn__content .column > div'
    );
    const parts = (dropdown?.textContent || '').split(' - ');
    const visitType = parts.length > 1 ? parts[parts.length - 1].trim() : '';
    if (visitType) noteType = visitType;
  } catch (e) {
    console.error('Error getting the note type');
    getLogFromInjector();
  }

  return {
    URL: baseURL,
    'Note Type': noteType
  };
}
// function getPatientInfo(){
export async function getPatientInfo() {
  /*
        Description: This function will get the patient info from the note
        Return: A dictionary with the patient info
    {
      "EMR ID": 0x1234 or "michalskij"
      "First Name":firstName,
      "Last Name": lastName,
      "DOB": dob,
    }
        */
  // name=ctl00_cp1_patientFirst
  // use the query selector to get the patient info
  try {
    let fullNameNeighborLS = document.querySelectorAll('.p-text-caption');
    let fullNameElement;
    for (let i = 0; i < fullNameNeighborLS.length; i++) {
      if (fullNameNeighborLS[i].textContent.trim() == 'Patient') {
        fullNameElement = fullNameNeighborLS[i].parentElement.children[1];
        break;
      }
    }

    if (!fullNameElement) {
      console.error('Full Name Element not found');
      return null;
    }

    const fullName = fullNameElement.textContent.trim();
    const res = getFirstAndLastName(fullName);
    const firstName = res['firstName'];
    const lastName = res['lastName'];
    const dob = '05/29/2023';
    const emrID = fullNameElement.nextElementSibling.textContent
      .replace('Acct#:', '')
      .trim();
    // Fetch additional content and metadata
    const metadata = await fetchMetadata();
    return {
      'EMR ID': emrID,
      'First Name': firstName,
      'Last Name': lastName,
      DOB: dob,
      Metadata: metadata
    };
  } catch (e) {
    console.error(`Error getting the patient info ${e}`);
    return null;
  }
}

function getFirstAndLastName(fullName) {
  // Define a regular expression to match the first name, optional nickname, and last name
  const nameRegex = /^(\w+)\s*(?:"(\w+)")?\s+(\w+)$/;
  const match = fullName.match(nameRegex);

  if (match) {
    const firstName = match[1];
    const nickname = match[2];
    const lastName = match[3];

    // If there's a nickname, include it in the first name
    const finalFirstName = nickname ? `${firstName} "${nickname}"` : firstName;

    return {
      firstName: finalFirstName,
      lastName: lastName
    };
  } else {
    return {
      firstName: fullName,
      lastName: ''
    };
  }
}

// Function to fetch metadata
async function fetchMetadata() {
  try {
    // Process all icons to fetch content
    let additionalContent = await processIcons();

    // Extract data from all sections
    const sectionData = await clickIntakeAndExtractData();

    // Collect and format metadata
    let metadata = '';
    metadata += `${additionalContent}\n`;

    if (sectionData) {
      for (const [section, data] of Object.entries(sectionData)) {
        let sectionContentAdded = false;

        // Check if there is any text field or checkbox to add
        if (data.textFields.length > 0 || data.checkboxes.length > 0) {
          metadata += `\n${section}:`;

          data.textFields.forEach((field) => {
            if (field.label && field.answer) {
              metadata += `\n- ${field.label}: ${field.answer}`;
              sectionContentAdded = true;
            }
          });

          // Only add checkboxes if no text fields were added
          if (data.checkboxes.length > 0 && !sectionContentAdded) {
            metadata += ` ${data.checkboxes.join(', ')}\n`;
          }

          if (sectionContentAdded) {
            metadata += '\n'; // Add a newline after the section content
          }
        }
      }
    }
    // Replace all instances of "Generate Ledger" with an empty string
    metadata = metadata.replace(/Generate Ledger/g, '');
    // Split the string into lines
    let lines = metadata.split('\n');

    // Process each line to remove extra spaces
    lines = lines.map((line) => line.trim().replace(/\s+/g, ' '));

    // Join the lines back together
    metadata = lines.join(' ');
    return metadata;
  } catch (e) {
    console.error(`Error fetching metadata: ${e}`);
    return 'Metadata could not be fetched.';
  }
}

// Function to click an icon, wait for content to appear, and then close it
async function clickAndLogContent(icon) {
  let additionalContent = '';
  if (icon.textContent.trim() === 'folder_shared') {
    icon.click();
    const menuSelector = 'div.q-menu.q-position-engine.scroll.q-pa-sm';
    const menu = await waitForElement(menuSelector);

    if (!menu) {
      console.error('Patient Ledger menu not found');
      return '';
    }
    menu.style.display = 'none'; // Hide the pop up

    // Check if the new content <div> with q-menu class appears
    const menuDiv = document.querySelector('div.q-menu');
    if (menuDiv && menuDiv.style.visibility === 'visible') {
      // Extract and log the content
      const content = menuDiv.innerText.trim();
      console.log(content);
      if (content) {
        additionalContent += content; // Accumulate content
      }
      // Close the menu
      icon.click();
    } else {
      console.log('Content not found or still not visible.');
    }
  }
  return additionalContent;
}

// Function to process all icons
async function processIcons() {
  // Find all <i> elements with the specified class names
  const icons = document.querySelectorAll(
    'i.q-icon.notranslate.material-icons'
  );
  let additionalContent = '';
  // Iterate through the elements
  for (const icon of icons) {
    const content = await clickAndLogContent(icon);
    additionalContent += content; // Accumulate content from all icons
  }
  return additionalContent;
}

// Function to click on the "Intake" element, extract section data, and then click "close" icon
async function clickIntakeAndExtractData() {
  try {
    // Find the "Intake" element
    const intakeSpan = Array.from(document.querySelectorAll('span')).find(
      (span) => span.textContent.trim() === 'Intake'
    );

    if (!intakeSpan) {
      console.error('Intake span element not found');
      return null;
    }

    // Click on the "Intake" element
    intakeSpan.click();

    // Wait for content to load or update (adjust the timeout as needed)
    // Wait for the q-card to appear
    const cardSelector = 'div.text-h6.text-p-gray600';
    const qCard = (await waitForElement(cardSelector))?.closest('.q-card');

    if (!qCard) {
      console.error('Intake Details not found');
      return null;
    }
    // Extract section data
    const sectionData = extractAllSectionsData();
    qCard.style.display = 'none'; // Hide the pop up

    // Click the "close" icon
    const closeButton = document.querySelector(
      'button.q-btn.q-btn--flat.text-p-gray400.q-btn--dense.q-ml-md'
    );

    if (closeButton) {
      // Click the close button
      closeButton.click();
      // Wait for any animations or content updates (adjust the timeout if necessary)
      await new Promise((resolve) => setTimeout(resolve, 1000));
      console.log('Popup closed successfully by clicking the close button');
    } else {
      console.log('Close button not found');
    }

    return sectionData;
  } catch (e) {
    console.error(`Error clicking Intake and extracting data: ${e}`);
    return null;
  }
}
// Utility function to wait for an element to be visible
function waitForElement(selector, timeout = 2000) {
  return new Promise((resolve, reject) => {
    const interval = 100;
    const totalWait = timeout;
    let elapsedTime = 0;

    const checkVisibility = () => {
      const element = document.querySelector(selector);
      if (element) {
        resolve(element);
      } else {
        elapsedTime += interval;
        if (elapsedTime >= totalWait) {
          reject(new Error('Element not found within timeout'));
        } else {
          setTimeout(checkVisibility, interval);
        }
      }
    };

    checkVisibility();
  });
}
// Function to extract data from all sections, including checkboxes and text areas
function extractAllSectionsData() {
  // Select all section headers
  const headers = document.querySelectorAll(
    'div.text-h6.q-pt-md, div.text-subtitle1.q-mb-sm'
  );

  let currentSection = null;
  let sectionData = {};
  let sectionOrder = [];

  headers.forEach((header) => {
    const headerText = header.textContent.trim();

    // Initialize section data if it doesn't exist
    if (!sectionData[headerText]) {
      sectionData[headerText] = { textFields: [], checkboxes: [] };
      sectionOrder.push(headerText); // Maintain order of sections
    }
    currentSection = headerText;

    // Process sibling elements for text fields and checkboxes
    let sibling = header.nextElementSibling;
    while (
      sibling &&
      !sibling.matches('div.text-h6.q-pt-md, div.text-subtitle1.q-mb-sm')
    ) {
      // Extract text areas (both textarea and contenteditable divs)
      const textAreas = sibling.querySelectorAll('textarea');
      textAreas.forEach((textarea) => {
        const label = textarea.getAttribute('aria-label')?.trim();
        const value = getTextInputValue(textarea)?.trim();

        if (label && value) {
          sectionData[currentSection].textFields.push({ label, answer: value });
        }
      });

      // Also check for contenteditable divs
      const contentEditableDivs = sibling.querySelectorAll(
        'div[contenteditable="true"]'
      );
      contentEditableDivs.forEach((div) => {
        const label = div.getAttribute('aria-label')?.trim();
        const value = getTextInputValue(div)?.trim();

        if (label && value) {
          sectionData[currentSection].textFields.push({ label, answer: value });
        }
      });

      // Extract checkboxes
      const checkboxes = sibling.querySelectorAll('div[role="checkbox"]');
      checkboxes.forEach((checkbox) => {
        const label = checkbox
          .querySelector('.q-checkbox__label')
          ?.textContent?.trim();
        const ariaChecked = checkbox.getAttribute('aria-checked') === 'true';

        if (label && ariaChecked) {
          sectionData[currentSection].checkboxes.push(label);
        }
      });

      // Move to the next sibling
      sibling = sibling.nextElementSibling;
    }
  });

  // Return section data with the correct format
  return sectionData;
}

// Helper Functions
function getParentSubtitle(elem) {
  var parent = elem.parentElement;
  var subtitle;
  var depth = 0;
  while (parent) {
    subtitle = parent.querySelector('.text-subtitle1');
    if (subtitle) {
      return subtitle.textContent.trim();
    }
    parent = parent.parentElement;
    depth++;
  }
  return null;
}

function getChildSubtitle(elem) {
  // Post update selector
  var subtitle = elem.querySelector('.command-input-label')?.textContent.trim();
  if (subtitle) {
    return subtitle;
  }
  subtitle = elem.querySelector('.text-subtitle1')?.textContent.trim();
  if (subtitle) {
    return subtitle;
  }
  return null;
}

function eventFactory(eventType) {
  return new Event(eventType, {
    bubbles: true, // If you want the event to bubble up through the DOM
    cancelable: true // If you want the event to be cancelable
  });
}

function getSelector(elm) {
  // This function will return the selector for a given element
  if (elm.tagName === 'BODY') return 'BODY';
  const names = [];
  while (elm.parentElement && elm.tagName !== 'BODY') {
    if (elm.id) {
      names.unshift('#' + elm.getAttribute('id')); // getAttribute, because `elm.id` could also return a child element with name "id"
      break; // Because ID should be unique, no more is needed. Remove the break, if you always want a full path.
    } else {
      let c = 1,
        e = elm;
      for (; e.previousElementSibling; e = e.previousElementSibling, c++);
      names.unshift(elm.tagName + ':nth-child(' + c + ')');
    }
    elm = elm.parentElement;
  }
  return names.join('>');
}

function findTemplate(element) {
  // Select all elements that could potentially contain the text
  var allElements = element.querySelectorAll('div'); // Adjust the tag names according to your needs

  // Iterate through the elements to find the one with "Text Templates"
  var foundElement = null;
  allElements.forEach(function (element) {
    if (element.textContent.includes('Text Templates')) {
      foundElement = element;
      // You can break out of the loop here if you want, but JavaScript doesn't have a built-in break for forEach
    }
  });

  // Check if an element was found and handle it
  if (foundElement) {
    return foundElement;
  } else {
    return null;
  }
}

function focusClick(elem) {
  elem.dispatchEvent(eventFactory('focusin'));
  elem.dispatchEvent(eventFactory('click'));
}

function findElementOfTypeWithText(baseElement, elementType, elementText) {
  var allElements = baseElement.querySelectorAll(elementType); // Adjust the tag names according to your needs
  var foundElement = null;
  for (var i = 0; i < allElements.length; i++) {
    if (allElements[i].textContent.includes(elementText)) {
      foundElement = allElements[i];
      break;
    }
  }
  return foundElement;
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function bubbleFocus(element: Element) {
  element.dispatchEvent(new FocusEvent('focusin', { bubbles: true, cancelable: true }));
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function nativeInputFill(element: HTMLInputElement | HTMLTextAreaElement, value: string) {
  const proto = element.tagName === 'TEXTAREA'
    ? window.HTMLTextAreaElement.prototype
    : window.HTMLInputElement.prototype;
  const nativeSetter = Object.getOwnPropertyDescriptor(proto, 'value')?.set;
  if (nativeSetter) {
    nativeSetter.call(element, value);
  } else {
    element.value = value;
  }
  element.dispatchEvent(new InputEvent('input', { bubbles: true }));
  element.dispatchEvent(new Event('change', { bubbles: true }));
}

function blockFor(milliseconds) {
  // Bad Practice....
  const start = Date.now();
  let current = null;
  do {
    current = Date.now();
  } while (current - start < milliseconds);
}

function waitForElementToDisplay(selector, maxTime) {
  var time = 10; // 100ms between checks
  return new Promise((resolve, reject) => {
    let totalTime = 0;

    function searchElement() {
      if (document.querySelector(selector) != null) {
        resolve('Element found');
      } else if (totalTime >= maxTime) {
        reject('Element not found within the specified time');
      } else {
        setTimeout(() => {
          totalTime += time;
          searchElement();
        }, time);
      }
    }

    searchElement();
  });
}

function choiceClicker(cpt, choice) {
  // This is the question answering function
  cpt.dispatchEvent(eventFactory('focusin'));
  cpt.dispatchEvent(eventFactory('click'));

  return waitForElementToDisplay('[role="listbox"]', 2000).then(function () {
    console.log('List Box Opened in the question answering function');
    var lBox = document.querySelector('[role="listbox"]');
    var qChoicesElement = lBox.querySelectorAll('.q-item__section');
    var found = false;
    qChoicesElement.forEach((innerElement) => {
      // innerElement.click() // (Toggles so we have to check it first)
      var localChoice = innerElement.textContent
        .trim()
        .replaceAll('\n        ', '');
      if (localChoice == choice) {
        if (!innerElement.parentElement.classList.contains('q-item--active')) {
          console.log('Clicking Choice: ' + choice);
          innerElement.click(); // (Toggles so we have to check it first)
          found = true;
        } else {
          console.log('Choice was already clicked!');
          found = true;
        }
      }
    });
    cpt.dispatchEvent(eventFactory('click')); // close it down...
    return found;
  });
}

async function tryToClick(selector, retryCount) {
  /*
    Description: This function will try to click an element, if the conditional is true, it will click it
    Otherwise it will try again in .1 seconds

    Args:
        selector: function that clicks a button and returns true if it was clicked, false otherwise (in a promise)
        retryCount: The number of times to retry
    
    Return: a promise that resolved to true if the element was clicked, false otherwise

    */

  if (retryCount <= 0) {
    console.error('Retry Count exceeded, element was not clicked');
    return false;
  }

  await sleep(100);

  console.log('Trying Selector');
  let result = await selector();
  console.log('Selector result = ' + result);
  if (result) {
    console.log('Element was clicked');
    return true;
  }

  // Did not return true, try again
  console.error('Element was not clicked, trying again in .1 seconds');
  return sleep(10).then(() => {
    return tryToClick(selector, retryCount - 1);
  });
}

function getTextInputElement(container) {
  // Try to find contenteditable div (new Prompt format)
  let element = container.querySelector('div[contenteditable="true"]');
  if (element) return element;

  // Try to find textarea (legacy) (Broken...)
  element = container.querySelector('textarea');
  return element;

  return null;
}

function getTextInputValue(input) {
  // Check if it's a textarea (has .value property)
  if (input.tagName === 'TEXTAREA') {
    return input.value;
  }
  // Check if it's a contenteditable div
  if (input.getAttribute('contenteditable') === 'true') {
    let content = input.textContent || input.innerText || '';
    content = content.trim();

    // If contenteditable has content, use it (post-click state)
    if (content && content.length > 0) {
      return content;
    }
    // Capture records what the clinician wrote, never the prompt text.
    if (capturingValues) return content;

    // If contenteditable is empty, check for placeholder text (pre-click state)
    // The placeholder might be hidden (display: none) but still have text
    const qEditor = input.closest('.q-editor');
    if (qEditor && qEditor.parentElement) {
      // Look for placeholder sibling of q-editor (even if hidden)
      const siblings = Array.from(qEditor.parentElement.children);
      for (const sibling of siblings) {
        if (
          sibling instanceof HTMLElement &&
          sibling.classList.contains('placeholder')
        ) {
          const placeholderText =
            sibling.textContent || sibling.innerText || '';
          if (placeholderText.trim()) {
            return placeholderText.trim();
          }
        }
      }
    }

    // Also check inside the container (fallback)
    const container = input.closest(
      '.q-editor, .command-input-wrapper, .full-width, .relative-position, label'
    );
    if (container) {
      const placeholder = container.querySelector('.placeholder');
      if (placeholder instanceof HTMLElement) {
        const placeholderText =
          placeholder.textContent || placeholder.innerText || '';
        if (placeholderText.trim()) {
          return placeholderText.trim();
        }
      }
    }

    return content;
  }
  return '';
}

function setTextInputValue(input, val) {
  // Check if it's a textarea (has .value property)
  if (isEmptyOrNull(val)) {
    return;
  }
  if (input.tagName === 'TEXTAREA') {
    input.value = val;
  }
  // Check if it's a contenteditable div
  else if (input.getAttribute('contenteditable') === 'true') {
    // For contenteditable divs, we need to preserve the HTML structure
    // Clear existing content
    input.innerHTML = '';

    // Split the value by newlines and create proper HTML structure
    const lines = val.split('\n');
    lines.forEach((line, index) => {
      if (index > 0) {
        input.appendChild(document.createElement('div'));
        const lastDiv = input.lastChild;
        lastDiv.appendChild(document.createElement('br'));
      }
      if (line.trim() !== '') {
        const div = document.createElement('div');
        div.textContent = line;
        input.appendChild(div);
      }
    });

    // Dispatch input event to notify the app of the change
    input.dispatchEvent(
      new Event('input', { bubbles: true, cancelable: true })
    );
  }
}

function isEmptyOrNull(value) {
  return (
    value === null || value === undefined || value === '' || value === 'None'
  );
}

function textBoxUpdate(input, val, replyType) {
  // This function will update the text box with the given text
  if (isEmptyOrNull(val)) {
    return;
  }
  if (!input) {
    console.error('No input element found for textBoxUpdate');
    return;
  }

  // Focus the element first (but don't click to avoid double clicks)
  if (input.focus) {
    input.focus();
  }

  // Only dispatch focus event, not click, to avoid double-clicking
  input.dispatchEvent(eventFactory('focus'));
  input.dispatchEvent(eventFactory('focusin'));
  input.dispatchEvent(eventFactory('compositionstart'));

  if (replyType == 'append') {
    const currentValue = getTextInputValue(input);
    setTextInputValue(input, currentValue + '\n' + val);
  } else {
    setTextInputValue(input, val);
  }

  input.dispatchEvent(eventFactory('compositionend'));
  input.dispatchEvent(eventFactory('input'));
  input.dispatchEvent(eventFactory('change'));
}

// This is where we will store the questions and interactions for populating the answers later
var questions = [];
var questionInteractions = {};

/**
 * Set only while readSectionForFocusCapture runs the extractors: they then
 * record every field's current value, including empty ones, and never the
 * placeholder text getTextInputValue otherwise falls back to.
 */
let capturingValues = false;
// Also only during that read: the section each question key was found in.
let captureSections: Map<string, string | null> | null = null;

// var questionsLoaded = false;    // Switches to true when the questions are loaded
let resolveQuestionsLoaded;
const questionsLoadedPromise = new Promise((resolve) => {
  resolveQuestionsLoaded = resolve;
});

export async function getQuestions() {
  try {
    // Get the questions
    questions = [];
    questionInteractions = {};

    var q = document.querySelectorAll('.q-pa-md');
    console.log('Questions');
    console.log(q);
    var section1 = q[0].firstChild.textContent.trim();

    // Store the scroll position
    const scrollTop = document.querySelector('#patientContainer').scrollTop;

    // For each of the questions
    for (var i = 1; i < q.length; i++) {
      try {
        await extractQuestionBlock(q[i]);
      } catch (error) {
        console.error('Error in loop iteration:', error);
        getLogFromInjector();
        // Handle error as needed
      }
    }
    extractAllSectionComments(); //doing here to avoid the order of questions mess up
    await getFlowsheet();
    console.log('Questions');
    console.log(questions);
    resolveQuestionsLoaded();

    // for each of the question add a new key called "Key" with the same value of "Question"
    for (var i = 0; i < questions.length; i++) {
      // Sometimes these labels will contain text such as "(Last Recorded on 11/21/2023)" we need to nuke and trim this
      questions[i]['Key'] = questions[i]['Question'];
    }

    // Reset the scroll
    document.querySelector('#patientContainer').scrollTop = scrollTop;
    questions = questions.filter(isReturnedQuestion);

    return questions;
  } catch (error) {
    // Handle error if it wasn't caught within the loop
    console.error('Error in getQuestions:', error);
    getLogFromInjector();
    // Send error to fetchDocument() or handle it as needed
  }
}

/* One `.q-pa-md` block of the document, by the kind of question it holds. */
async function extractQuestionBlock(block) {
  // Check for the top level questions
  if (block.querySelectorAll('.q-mb-md').length > 0) {
    await topLevelShortAnswer(block);
  } else if (block.querySelector('[role="combobox"]')) {
    // Choose all - Toggle Box
    // await comboBoxQuestion(block);
    // We don't even work with the CPT Codes so let's not scroll down so hard
  } else if (block.querySelector('.q-px-md')) {
    // Check if it is a choose all question
    await chooseAllQuestion(block);
  } else if (
    block.querySelector('.radioGroup') &&
    !getTextInputElement(block)
  ) {
    // Added the check for a text area for goal questions
    // Multiple Choice
    await multipleChoiceQuestion(block);
    // TODO: This is too generic...
  } else if (getTextInputElement(block)) {
    // Long Answer Question (textarea or contenteditable div)
    await longAnswerQuestion(block);
  } else {
    // console.log("Unknown Question Type")
    // console.log(block)
  }
}

/* The questions getQuestions returns, after dropping Prompt's noise. */
function isReturnedQuestion(question) {
  // Remove Null and empty questions
  if (question === null || question === undefined || question.Question === '') {
    return false;
  }
  // Remove Goal Progress (%) questions
  if (!question.Question || question.Question.includes('Goal Progress (%)')) {
    return false;
  }
  // Remove Flex questions with no structure (e.g. Flowsheet with empty table)
  if (
    question.Type === 'Flex' &&
    Object.keys(question.Structure ?? {}).length === 0
  ) {
    return false;
  }
  // Remove noise questions from Prompt
  // Drops "Treatment Notes", "Treatment Notes (Never Completed)", and any other suffixed variant.
  // Note: the Flowsheet Flex structure holds its own 'Treatment Notes' key, so it is unaffected.
  return !question.Question?.trim().startsWith('Treatment Notes');
}

// All the questions have their own function so we can call them individually
async function topLevelShortAnswer(question) {
  // console.log("Top Level Long Answer")
  var shortAnswer1 = question.querySelectorAll('.q-mb-md');

  var qType = 'Long Answer';

  // Subjective, Objective, Assessment, Plan
  shortAnswer1.forEach((element) => {
    var qText = element.firstChild?.getAttribute?.('label');
    if (!qText)
      qText = element
        .querySelector('.command-input-label')
        ?.textContent?.trim();
    if (!qText) qText = element.querySelector('[label]')?.getAttribute('label');
    if (!qText)
      qText = element.querySelector('.q-field__label')?.textContent?.trim();
    if (!qText) return; // skip structural wrappers with no label

    var qInteraction = {};
    var existingNoteElement = getTextInputElement(element);
    if (existingNoteElement) {
      qInteraction['ExistingNote'] = getExistingNote(
        getTextInputValue(existingNoteElement)
      );
    }
    qInteraction['Input'] = (val, replyType) =>
      textBoxUpdate(getTextInputElement(element), val, replyType); // Store the interaction for later

    try {
      qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
    } catch (e) {
      console.error(
        'Error removing the last recorded text, trying as a long answer directly'
      );
      return longAnswerQuestion(question);
    }

    questions.push({
      Question: qText,
      Type: qType,
      ExistingNote: qInteraction['ExistingNote'],
      Choices: []
    });
    questionInteractions[qText] = qInteraction;
  });
}

async function comboBoxQuestion(question) {
  // console.log("ComboBox Question")
  var cpt = question.querySelector('[role="combobox"]');

  var qText = getParentSubtitle(cpt);
  // if qText starts with "This template will"
  if (qText.startsWith('This template will')) {
    return null;
  }

  var qType = 'Choose All';
  var qInteraction = {};
  var qChoices = [];

  // Show the choices drop down
  cpt.dispatchEvent(eventFactory('focusin'));
  cpt.dispatchEvent(eventFactory('click'));

  // Rather than using a while loop with a sleep, we could use a promise

  return waitForElementToDisplay('[role="listbox"]', 2000)
    .then(function () {
      // console.log("List Box found!")
      var lBox = document.querySelector('[role="listbox"]');
      var qChoicesElement = lBox.querySelectorAll('.q-item__section');
      qChoicesElement.forEach((element) => {
        // var choice = element.textContent.trim().replaceAll("\n        ","")
        // Rather than getting the code and description, just get the code
        var choice = element.firstChild.textContent.trim();
        qChoices.push(choice);
        qInteraction[choice] = () =>
          tryToClick(() => choiceClicker(cpt, choice), 5);
      });

      try {
        qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
      } catch (e) {
        console.error('Error removing the last recorded text');
        getLogFromInjector();
      }

      // Push the choices to the questions
      questions.push({ Question: qText, Type: qType, Choices: qChoices });
      questionInteractions[qText] = qInteraction;
      console.log(questions[questions.length - 1]);
      // Close the choices drop down
      cpt.dispatchEvent(eventFactory('click'));
      return true;
    })
    .catch(function () {
      console.error('List Box not found');

      return null;
    });
}

async function chooseAllQuestion(question) {
  // console.log("Choose All Question")
  var chooseAll = question.querySelectorAll('.q-px-md');
  var qText = getChildSubtitle(question);
  if (!qText) return;
  var qType = 'Choose All';
  var qChoices = [];

  var qInteraction = {};

  chooseAll.forEach((element) => {
    // Make sure we have a checkbox (Plan of care was coming here and failing)
    if (!element.querySelector('.q-checkbox__inner')) {
      return;
    }
    var choiceText = element.textContent.trim();
    qChoices.push(choiceText);
    qInteraction[choiceText] = () => {
      if (
        !element
          .querySelector('.q-checkbox__inner')
          .classList.contains('q-checkbox__inner--truthy')
      ) {
        element.querySelector('.q-checkbox__inner').click(); // This is how we click it
      }
    };
  });

  try {
    qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
  } catch (e) {
    console.error('Error removing the last recorded text');
    getLogFromInjector();
  }

  questions.push({
    Question: qText,
    Type: qType,
    Choices: qChoices,
    ...(capturingValues
      ? {
          'Existing Value': Array.from(chooseAll as NodeListOf<Element>)
            .filter((element) =>
              element
                .querySelector('.q-checkbox__inner')
                ?.classList.contains('q-checkbox__inner--truthy')
            )
            .map((element) => element.textContent.trim())
        }
      : {})
  });
  questionInteractions[qText] = qInteraction;
}

function extractAllSectionComments() {
  // Find all visible q-card elements
  const qCards = document.querySelectorAll('.q-card');

  qCards.forEach((qCard) => {
    try {
      // Check if the q-card element is visible
      if (getComputedStyle(qCard).display !== 'none') {
        // Within each visible q-card, find all text areas
        const sections = qCard.querySelectorAll('div[contenteditable]');

        sections.forEach((section) => {
          // Find the closest parent element with class 'relative-position full-width'
          const parentElement = section.closest(
            '.relative-position.full-width'
          );

          const headerElement = parentElement.querySelector('.q-field__label');
          const textArea = getTextInputElement(section.parentElement);

          if (headerElement && textArea) {
            const header = headerElement.textContent.trim();
            const comment = getTextInputValue(textArea).trim();

            // Update header text to remove "(Last recorded on [date])" and make it generic
            let qText = header.replace(/\(Last recorded.*?\)/, '').trim();
            // Optionally, replace specific labels with a generic "Comments"
            if (qText) {
              qText = qText.replace(/Based Assessment$/, 'Comments'); // Generic replacement
            }

            const qType = 'Long Answer';
            const qChoices = [];
            captureSections?.set(qText, promptNotePage.sectionOf(section));
            const qInteraction = {
              ExistingNote: comment,
              Input: (val, replyType) => textBoxUpdate(textArea, val, replyType)
            };

            questions.push({
              Question: qText,
              Type: qType,
              ExistingNote: qInteraction['ExistingNote'],
              Choices: qChoices
            });

            // Remove duplicate questions
            const uniqueQuestions = Array.from(
              new Map(questions.map((q) => [q.Question, q])).values()
            );
            questions = uniqueQuestions;
            questionInteractions[qText] = qInteraction;
          }
        });
      }
    } catch (error) {
      if (!capturingValues) {
        console.error('Error extracting comments for section:', error);
      }
    }
  });

  if (!capturingValues) console.log('questions', questions);
}

async function multipleChoiceQuestion(question) {
  // console.log("Multiple Choice Question")
  var mcChoice = question.querySelectorAll('button');
  var qText = getChildSubtitle(question);
  if (!qText || qText == 'Measurements') {
    return null;
  }

  // if qText starts with "This template will"
  if (qText.startsWith('This template will')) {
    return null;
  }

  var qType = 'Multiple Choice';
  var qChoices = [];
  var qInteraction = {};
  var qSelected = '';

  mcChoice.forEach((element) => {
    var choiceText = element
      .querySelector('.q-btn__content')
      .firstChild.firstChild.textContent.trim();
    qChoices.push(choiceText);
    if (element.classList.contains('bg-p-blue100')) qSelected = choiceText;

    qInteraction[choiceText] = () => {
      if (!element.classList.contains('bg-p-blue100')) {
        element.click(); // (Toggles so we have to check it first)
      }
    };
  });

  try {
    qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
  } catch (e) {
    console.error('Error removing the last recorded text');
    getLogFromInjector();
  }

  questions.push({
    Question: qText,
    Type: qType,
    Choices: qChoices,
    ...(capturingValues ? { 'Existing Value': qSelected } : {})
  });
  questionInteractions[qText] = qInteraction;
}

async function longAnswerQuestion(question) {
  // console.log("Long Answer Question")
  var qText = getChildSubtitle(question);
  if (!qText || qText == 'Measurements') {
    return null;
  }

  var qType = 'Long Answer';
  var qChoices = [];
  var qInteraction = {};
  var existingNoteElement = getTextInputElement(question);
  if (existingNoteElement) {
    qInteraction['ExistingNote'] = getExistingNote(
      getTextInputValue(existingNoteElement)
    );
  }
  qInteraction['Input'] = (val, replyType) =>
    textBoxUpdate(getTextInputElement(question), val, replyType); // Store the interaction for later

  // Check if there is already an entry in questionInterations with qText, if so append a number to it
  if (qText in questionInteractions) {
    var i = 1;
    var qTextTemp = qText;
    while (qTextTemp in questionInteractions && i < 10) {
      i++;
      qTextTemp = qText + ' #' + i;
    }
    qText = qText + ' #' + i;
  }

  try {
    qText = qText.replace(/\(Last recorded.*?\)/, '').trim();
  } catch (e) {
    console.error('Error removing the last recorded text');
    getLogFromInjector();
  }

  questions.push({
    Question: qText,
    Type: qType,
    ExistingNote: qInteraction['ExistingNote'],
    Choices: qChoices
  });
  questionInteractions[qText] = qInteraction;
  if (!capturingValues) console.log('questions', questions);
}

async function scrapeTemplates(element, bodyPart, section) {
  console.log('Scraping Templates');
  // Get the template button
  var t = findTemplate(element);
  if (!t) {
    // console.log("Template button not found")
    return null;
  }

  t.click(); // Shows the template manager

  var tDialog = document.querySelector('.q-dialog');

  // Set the body part
  var bodyPartButton =
    tDialog.querySelectorAll('.q-field__inner')[0].firstChild;
  bodyPartButton.click();
  var lBox = document.querySelectorAll('[role="listbox"]')[0];
  var choicesSelector = lBox.querySelectorAll('.q-px-md');
  var choices = [];
  for (var i = 0; i < choicesSelector.length; i++) {
    var code = choicesSelector[i].children[0].textContent.trim();
    var description = choicesSelector[i].children[1].textContent.trim();
    choices.push(code + ' - ' + description);
  }
  var bodyPartIndex = choices.indexOf(bodyPart);
  if (bodyPartIndex == -1) {
    console.error('Body Part not found');
    return null;
  }
  choicesSelector[bodyPartIndex].click();

  // Set the section
  var sectionButton = tDialog.querySelectorAll('.q-field__inner')[1].firstChild;
  sectionButton.click();
  var lBox = document.querySelectorAll('[role="listbox"]')[0];
  var choicesSelector = lBox.querySelectorAll('.q-item__section');
  var choices = [];
  for (var i = 0; i < choicesSelector.length; i++) {
    var code = choicesSelector[i].children[0].textContent.trim();
    var description = choicesSelector[i].children[1].textContent.trim();
    choices.push(code + ' - ' + description);
  }
  var sectionIndex = choices.indexOf(section);
  if (sectionIndex == -1) {
    console.error('Section not found');
    return null;
  }
  choicesSelector[sectionIndex].click();

  // Get the templates
  var templates = tDialog.querySelector('.q-table__grid-content').children;
  var templates = [];
  for (var i = 0; i < templates.length; i++) {
    templates.push(templates[i].textContent.split('...see more')[0].trim());
  }

  // Close the template manager
  findElementOfTypeWithText(tDialog, 'i', 'close').click();

  return templates;
}

// function answerQuestions(answers){
export function answerQuestions(answers) {
  /*
    Description: This function will take the answers and populate the questions
    
    Args: 
        answers: A dictionary of answers
            "Question": "The question in question"
            "Answer": "The answer to the question"
   
    Return: A list of any questions that were not answered, perhaps the answer didn't match the questions expected or whatnot...
        [
            {
                Question: "Where was the injury?", 
                Answer: "Back" 
                Error: "The error message" (Choice not found, etc)
            },
            ...
        }

    */
  var errors = [];
  answers.forEach((answer) => {
    var error = answerQuestion(answer['Question'], answer['Answer']);
    if (error) {
      errors.push({
        Question: answer['Question'],
        Answer: answer['Answer'],
        Error: error
      });
    }
  });
  console.error('Errors:');
  console.error(errors);
  return errors;
}

function normalizeKey(key: string): string {
  return key.replace(/[^\w\s]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
}

async function answerFlexQuestion(question, answer, replyType = 'overwrite') {
  const structure = questionInteractions[question]?.Structure || {};

  // Build a normalized lookup so AI keys like "Y Balance" match '"Y" Balance'
  const normalizedStructure: Record<string, any> = {};
  for (const key of Object.keys(structure)) {
    normalizedStructure[normalizeKey(key)] = structure[key];
  }

  for (const [fieldKey, fieldValue] of Object.entries(answer)) {
    const field = structure[fieldKey] ?? normalizedStructure[normalizeKey(fieldKey)];

    if (!field) {
      console.warn(`Flowsheet: field "${fieldKey}" not found in structure`);
      continue;
    }

    // fieldValue is a sub-object of {label: value} pairs for each treatment
    if (typeof fieldValue === 'object' && fieldValue !== null) {
      for (const [subKey, value] of Object.entries(fieldValue)) {
        const sub = field[subKey];
        if (!sub?.Input) {
          console.warn(`Flowsheet: sub-field "${fieldKey}.${subKey}" has no Input`);
          continue;
        }
        if (value !== null && value !== undefined && value !== '') {
          try {
            await sub.Input(String(value), replyType);
            await sleep(50);
            (document.activeElement as HTMLElement)?.blur();
          } catch (e) {
            console.error(`Flowsheet: error filling "${fieldKey}.${subKey}": ${e}`);
          }
        }
      }
    }
  }
}

// async function answerQuestion(question, answer, replyType){
export async function answerQuestion(question, answer, replyType) {
  /*
    Description: This function will take the answer and populate the question
    
    Args: 
        question: The question in question
        answer: The answer to the question
   
    Return: null if success otherwise a string with the error message
    */

  await questionsLoadedPromise; // Wait for the questions to load

  console.log("Answering Question: '" + question + "' with '" + answer + "'");

  // Make sure the question exists
  if (questionInteractions[question] == null) {
    console.error('Question not found');
    console.log(questionInteractions);

    console.log(Object.keys(questionInteractions));

    return 'Question not found';
  }

  // Flex question (e.g. Flowsheet)
  if (questionInteractions[question]['Type'] === 'Flex') {
    await answerFlexQuestion(question, answer, replyType);
    return true;
  }

  // If it is a Long Answer or long answer, just populate the input
  if (questionInteractions[question]['Input']) {
    questionInteractions[question]['Input'](answer, replyType);
    return true;
  }

  // Check if the answer is a list of answers or just a single answer
  if (Array.isArray(answer)) {
    // Choose All
    var notFoundAnswers = [];
    for (var i = 0; i < answer.length; i++) {
      if (answer[i] in questionInteractions[question]) {
        console.log('Answer found ' + answer[i]);
        await questionInteractions[question][answer[i]]();
        // sleep(1000).then(() => {
        //     questionInteractions[question][answer[i]]()
        // });
      } else {
        notFoundAnswers.push(answer[i]);
      }
    }
    // answer.forEach(element => {
    //     if (element in questionInteractions[question]){
    //         console.log("Answer found " + element)
    //         questionInteractions[question][element]()
    //     } else {
    //         notFoundAnswers.push(element)
    //     }
    // });
    if (notFoundAnswers.length > 0) {
      console.error('The following answers were not found: ' + notFoundAnswers);
      return 'The following answers were not found: ' + notFoundAnswers;
    } else {
      return true;
    }
  } else {
    // Multiple Choice
    if (answer in questionInteractions[question]) {
      questionInteractions[question][answer]();
      return true;
    } else {
      console.error('Answer not found');
      return 'Answer not found';
    }
  }
}

export async function getFlowsheet() {
  try {
    const check = 'Flowsheet';

    if (!questionInteractions[check]) {
      questionInteractions[check] = {
        Type: 'Flex',
        Key: check,
        Question: check,
        Structure: {},
        ReplyType: 'overwrite'
      };
      // Share the same Structure reference so localQuestions[key].Structure is populated
      questions.push({ Question: check, Type: 'Flex', Choices: [], Structure: questionInteractions[check].Structure });
    } else if (Object.keys(questionInteractions[check].Structure).length > 0) {
      console.log('Flowsheet already handled');
      return;
    }

    const structure = questionInteractions[check].Structure;

    // Wait for the flowsheet table to render (mirrors WebPTSoap2's revealFlowsheetTextarea pattern)
    let attempts = 0;
    while (
      !capturingValues &&
      document.querySelectorAll('table tbody tr').length === 0 &&
      attempts++ < 10
    ) {
      await sleep(400);
    }

    const rows = document.querySelectorAll('table tbody tr');
    if (!capturingValues) {
      console.log(`Flowsheet: found ${rows.length} row(s) after ${attempts} attempt(s)`);
    }

    rows.forEach((row, index) => {
      const nameEl = row.querySelector('.omni-type-s span');
      if (!nameEl) return;

      const rawName = nameEl.textContent?.trim() || `Treatment ${index + 1}`;
      let finalName = rawName;
      let counter = 2;
      while (structure[finalName]) {
        finalName = `${rawName} (${counter++})`;
      }

      const container = {};
      const seen = new Set<string>();

      const inputs = row.querySelectorAll('input, textarea');
      if (!inputs || inputs.length === 0) {
        console.warn(`Flowsheet row "${finalName}" has no inputs, skipping.`);
        return;
      }

      inputs.forEach((input: Element) => {
        const el = input as HTMLInputElement | HTMLTextAreaElement;
        const label = el.getAttribute('aria-label')?.trim();
        if (!label || seen.has(label)) return;
        seen.add(label);

        // CPT Code is a combobox — disabled for now
        if (label === 'CPT Code') {
          return;
        }

        // Textarea (Treatment Notes)
        if (el.tagName === 'TEXTAREA') {
          container[label] = {
            ...((el.value || capturingValues) && { 'Existing Value': el.value }),
            Input: (val: string) => {
              bubbleFocus(el);
              nativeInputFill(el, val);
              el.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
              el.blur();
            }
          };
          return;
        }

        // All other inputs (Min., Set, Rep, Wt., Sec)
        const isNumeric = (el as HTMLInputElement).type === 'number';
        container[label] = {
          ...(isNumeric && { Type: 'Integer' }),
          ...((el.value || capturingValues) && { 'Existing Value': el.value }),
          Input: (val: string) => {
            bubbleFocus(el);
            nativeInputFill(el as HTMLInputElement, val);
            el.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
            el.blur();
          }
        };
      });

      // Treatment Notes — rendered as a contenteditable div with a hidden sync textarea.
      // The input/textarea scan above never sees it: the hidden textarea has no aria-label.
      const noteCE = row.querySelector('.q-field__native div[contenteditable]') as HTMLElement | null;
      if (noteCE && !seen.has('Treatment Notes')) {
        seen.add('Treatment Notes');
        const hiddenTa = noteCE.parentElement?.querySelector('textarea') as HTMLTextAreaElement | null;
        const existingNote = noteCE.textContent?.trim() || hiddenTa?.value?.trim() || '';
        container['Treatment Notes'] = {
          ...((existingNote || capturingValues) && { 'Existing Value': existingNote }),
          Input: (val: string) => {
            bubbleFocus(noteCE);
            noteCE.focus();
            // Select all existing content, then insertText so Vue's input listener
            // fires with a real editing event (works for contenteditable="plaintext-only")
            const sel = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(noteCE);
            sel?.removeAllRanges();
            sel?.addRange(range);
            const ok = document.execCommand('insertText', false, val);
            if (!ok || noteCE.textContent !== val) {
              // Fallback: set content directly and synthesize the input event
              noteCE.textContent = val;
              noteCE.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: val }));
            }
            // Keep the hidden textarea in sync in case the component reads from it
            if (hiddenTa && hiddenTa.value !== val) {
              nativeInputFill(hiddenTa, val);
            }
            noteCE.dispatchEvent(new FocusEvent('focusout', { bubbles: true }));
            noteCE.blur();
          }
        };
      }

      // Bodypart/Condition combobox
      const bodyPartInput = row.querySelector('input[aria-label="Bodypart/Condition"]') as HTMLInputElement | null;
      if (bodyPartInput) {
        container['Bodypart/Condition'] = {
          ...((bodyPartInput.value || capturingValues) && { 'Existing Value': bodyPartInput.value }),
          Choices: ['Abdomen','Ankle','Arm','Back','Cervical','Chest','Elbow','Finger','Foot','Hand','Head','Hip','Jaw','Knee','Leg','N/A','Pelvis','Shoulder','Toe','Ulna','Wrist'],
          Input: async (val: string) => {
            if (bodyPartInput.value === val) return;
            const control = bodyPartInput.closest('.q-field__control') as HTMLElement | null;
            if (!control) return;
            control.dispatchEvent(eventFactory('focusin'));
            control.click();
            let a = 0;
            while (!document.querySelector('[role="listbox"]') && a++ < 20) {
              await sleep(100);
            }
            const listbox = document.querySelector('[role="listbox"]');
            if (!listbox) { control.click(); return; }
            // Focus + fill search box to filter (bypasses virtual scroll)
            const searchInput = listbox.querySelector('input[type="search"]') as HTMLInputElement | null;
            if (searchInput) {
              searchInput.focus();
              nativeInputFill(searchInput, val);
              await sleep(300);
            }
            for (const item of Array.from(listbox.querySelectorAll('.p-select__option-title'))) {
              if (item.textContent?.trim() === val) {
                (item as HTMLElement).click();
                return;
              }
            }
            control.click(); // close if not found
          }
        };
      }

      // Side (L / R) toggle buttons
      const sideGroup = (row.querySelector('.showDesktopPTable') ?? row.querySelector('.hideDesktopPTable')) as Element | null;
      if (sideGroup) {
        const sideBtns = Array.from(sideGroup.querySelectorAll('button'));
        const currentSide = sideBtns
          .find(b => b.classList.contains('bg-p-blue100'))
          ?.querySelector('.text-p-subtitle2')?.textContent?.trim();
        const sideChoices = sideBtns
          .map(b => b.querySelector('.text-p-subtitle2')?.textContent?.trim())
          .filter((s): s is string => !!s);
        if (sideChoices.length > 0) {
          container['Side'] = {
            ...((currentSide || capturingValues) && { 'Existing Value': currentSide ?? '' }),
            Choices: sideChoices,
            Input: (val: string) => {
              const target = sideBtns.find(b =>
                b.querySelector('.text-p-subtitle2')?.textContent?.trim() === val
              ) as HTMLElement | undefined;
              if (target && !target.classList.contains('bg-p-blue100')) {
                target.click();
              }
            }
          };
        }
      }

      // Performed / Not Performed
      const performedBtn = row.querySelector('[data-testid="button-exerciseCompleted"]') as HTMLElement | null;
      if (performedBtn) {
        const isPerformed = performedBtn.classList.contains('bg-p-green100');
        container['Performed'] = {
          'Existing Value': isPerformed ? 'Performed' : 'Not Performed',
          Choices: ['Performed', 'Not Performed'],
          Input: (val: string) => {
            // Re-query to avoid stale reference after Vue re-render
            const checkBtn = row.querySelector('[data-testid="button-exerciseCompleted"]') as HTMLElement | null;
            const currentlyPerformed = checkBtn?.classList.contains('bg-p-green100') ?? false;
            const wantPerformed = val === 'Performed';
            if (wantPerformed && !currentlyPerformed) {
              checkBtn?.click();
            } else if (!wantPerformed && currentlyPerformed) {
              (checkBtn?.previousElementSibling as HTMLElement | null)?.click();
            }
          }
        };
      }

      if (Object.keys(container).length > 0) {
        structure[finalName] = container;
      }
    });

    if (!capturingValues) console.log('Flowsheet structure:', structure);
  } catch (e) {
    // A capture reads quietly: errors here would be relayed on every read.
    if (capturingValues) return;
    console.error(`Error in getFlowsheet: ${e}`);
    getLogFromInjector();
  }
}

function getExistingNote(value) {
  if (typeof value !== 'string') {
    return null;
  }

  let val = value?.trim();
  return val === '' ? null : val;
}

export async function getLogFromInjector() {
  try {
    const htmlContent = document.documentElement.outerHTML;
    return new Promise((resolve, reject) => {
      chrome.runtime.sendMessage(
        { type: 'INJECTOR_ERROR', error: { htmlContent: htmlContent } },
        (response) => {
          if (chrome.runtime.lastError) {
            reject(chrome.runtime.lastError);
          } else {
            resolve({ htmlContent: htmlContent });
          }
        }
      );
    });
  } catch (error) {
    // Return the full HTML content of the document
    console.error('Error occurred while fetching document:', error);
    return Promise.reject(error);
  }
}

/*
Get All Notes for Prompt (NoteFocusCapture.ts). Deliberately not the
*ForCapture exports: those also enable NoteCapture's poller and other paths.
The page facts come from PromptCapture.ts; the values from this injector's own
extractors, so they are keyed exactly as getQuestions keys them and line up
with what Comprehend wrote.
*/
export const noteFocusCapture: FocusCaptureSource = {
  ...promptNotePage,
  readSection: readSectionForFocusCapture
};

/**
 * The current values of the getQuestions questions found in one section,
 * keyed by question. The note read runs the extractors into private globals,
 * so a capture between GET_DOM and PUSH_ANSWER never replaces the
 * questionInteractions that answerQuestion fills from, and never awaits. It
 * only reads the DOM.
 */
function readSectionForFocusCapture(section: string): SectionRead | null {
  if (!promptNotePage.listSections().includes(section)) return null;
  const note = sharedNoteRead();
  const values: Record<string, any> = {};
  Object.entries(note.values).forEach(([key, value]) => {
    if (note.sections.get(key) === section) values[key] = value;
  });
  return { values };
}

/*
Reading every section in one go (a note opening, a Comprehend link) would walk
the whole note once per section. The page cannot change within one task, so
the reads in one task share a single walk.
*/
let noteReadInTask: ReturnType<typeof readNoteForCapture> | null = null;

function sharedNoteRead() {
  if (!noteReadInTask) {
    noteReadInTask = readNoteForCapture();
    queueMicrotask(() => {
      noteReadInTask = null;
    });
  }
  return noteReadInTask;
}

/** Every returned question's current value, and the section it was found in. */
function readNoteForCapture() {
  const savedQuestions = questions;
  const savedInteractions = questionInteractions;
  questions = [];
  questionInteractions = {};
  capturingValues = true;
  captureSections = new Map();
  const sections = captureSections;
  try {
    // getQuestions numbers repeated labels in document order ("General Notes
    // #2"), so the whole note is walked to key every question the same way.
    const blocks = document.querySelectorAll('.q-pa-md');
    for (let i = 1; i < blocks.length; i++) {
      const before = questions.length;
      // Every extractor this reaches finishes before its first await.
      extractQuestionBlock(blocks[i]).catch(() => {});
      const blockSection = promptNotePage.sectionOf(blocks[i]);
      questions.slice(before).forEach((question) => {
        if (question?.Question) sections.set(question.Question, blockSection);
      });
    }
    extractAllSectionComments();
    // With capturingValues set it never waits for the table, so it never awaits.
    void getFlowsheet();
    sections.set(FLOWSHEET, FLOWSHEET);

    const values: Record<string, any> = {};
    questions.filter(isReturnedQuestion).forEach((question) => {
      values[question.Question] = capturedValue(question);
    });
    return { values, sections };
  } finally {
    questions = savedQuestions;
    questionInteractions = savedInteractions;
    capturingValues = false;
    captureSections = null;
  }
}

function capturedValue(question) {
  if (question.Type === 'Flex') {
    const rows: Record<string, any> = {};
    Object.entries(question.Structure || {}).forEach(([row, fields]) => {
      rows[row] = {};
      Object.entries(fields as Record<string, any>).forEach(([field, entry]) => {
        rows[row][field] = entry['Existing Value'] ?? '';
      });
    });
    return rows;
  }
  if ('Existing Value' in question) return question['Existing Value'];
  return question.ExistingNote ?? '';
}
